module.exports = __webpack_public_path__ + "img/area-rounded.9a285469.svg";